import Accordion from "react-bootstrap/Accordion";

// FAQ block shared by the pricing page and the discount offer page
// (extracted verbatim from InstructorPricing for MGDWD-186).
function PricingFaq() {
	return (
		<Accordion flush className="pt-4">
			<Accordion.Item eventKey="4">
				<Accordion.Header>What Is MyGolfDNA?</Accordion.Header>
				<Accordion.Body>
					<p>Our membership-based virtual golf instruction portal is designed for players of all ages and skill levels.</p>
					<p>Members gain exclusive access to high-quality instructional videos and a personalized learning system that adapts to each individual’s needs. Our primary focus is on protecting your body while maximizing efficiency in your golf swing.</p>
					<p>With our virtual lesson portal, students can submit videos of their golf swings 24/7 and receive customized feedback, along with a tailored lesson plan and strategy. The number of virtual lessons and response times depend on the membership tier you choose.</p>
				</Accordion.Body>
			</Accordion.Item>
			<Accordion.Item eventKey="0">
				<Accordion.Header>What Is A Virtual Lesson?</Accordion.Header>
				<Accordion.Body>
					Virtual lessons allow you to submit a video of your swings for review. We’ll use our analysis tool to evaluate your swings or drills and provide feedback. Once your lesson is ready, you’ll receive a video on your DNA Profile page, along with a notification. Your lesson will include details on what to work on, why it’s important, and how to make improvements. We’ll also include helpful focus videos on the website to support your lesson.
				</Accordion.Body>
			</Accordion.Item>
			<Accordion.Item eventKey="1">
				<Accordion.Header>How Often Can I Submit Virtual Lessons?</Accordion.Header>
				<Accordion.Body>
					You can submit virtual lessons whenever you'd like, or as allowed by your membership tier. Remember, this process is designed to support you every step of the way.
				</Accordion.Body>
			</Accordion.Item>
			<Accordion.Item eventKey="2">
				<Accordion.Header>How Do I Ask Questions Specific To My Virtual Lesson?</Accordion.Header>
				<Accordion.Body>
					Go to your MyDNA Profile and find the lesson widget. There, you'll see a tab to click that opens a question box next to the lesson review you have questions about. Please note that lesson-specific questions can only be asked within 7 days of completing a lesson.
				</Accordion.Body>
			</Accordion.Item>
			<Accordion.Item eventKey="3">
				<Accordion.Header>What is PocketPRO?</Accordion.Header>
				<Accordion.Body>
					This feature gives you 24/7 access to your instructor for live virtual feedback during practice sessions, range time, or even on the course. In simple terms, it's private instruction online through platforms like Zoom or Google Meet. Think of it as a powerful supplement to your virtual lessons, helping you get even more personalized guidance.
				</Accordion.Body>
			</Accordion.Item>
			<Accordion.Item eventKey="5">
				<Accordion.Header>How Does The 30-Day Money Back Guarantee Work?</Accordion.Header>
				<Accordion.Body>
					<p>If you know me, you know I’m not a fan of subscription programs that don’t deliver. I’m guessing you feel the same way.</p>
					<p>If you use GolfDNA consistently for 30 days and don’t feel more confident, more consistent,
						and more in control of your golf swing, we’ll refund your first month and cancel your
						subscription — no questions asked. Just email us at support@mygolfdna.com.</p>
				</Accordion.Body>
			</Accordion.Item>
		</Accordion>
	);
}

export default PricingFaq;
